import {
  type IServiceRouteListProps,
  type IRouteListProps,
  type IPagesConstantListProps,
} from 'types';

export const RouteList: IRouteListProps = {
  Home: '/',
  OrgHome: '/',
  Dashboard: '/dashboard',
  Complaints: '/complaints',
  CustomerDetails: '/customer-details/:id',
  EmployessDetails: '/employees-details/:id',
  EmployeeContributionDetails: '/employee-contribution-details/:userId',
  Customers: '/customers',
  Users: '/users',
  Employers: '/employers',
  FundManagement: '/fundmanagement',
  Onboarding: '/onboarding',
  OnboardingByUser: '/onboarding/:userId',
  Admins: '/admins',
  Logout: '/logout',
  UserPlanContribution: '/user-plan-contribution',
  UserWiseContribution: '/user-wise-contribution',
  EmployerDetails: '/employer-details/:orgId',
  EmployeeView: '/total-empoyees',
  ChartDetails: '/empoyees-chart-details/:orgId',
  Uploads: '/uploads',
  UploadDetails: '/upload-details/:id',
  Chats: '/chats',
  Orders: '/orders',
  CustomerChat: '/customer-chat/:id',
  CustomerComplaints: '/customer-complaints/:complaintId',
  Requests: '/requests',
  UserRequestDetails: '/user-request-details/:requestId',
  ReportBankFile: '/bank-file-record-report',
  // Transfers: '/transfers',
  // TransferDetails: 'transfer-details/:userId',
  FeeCalculation: '/fee-calculation',
  OtpVerification: '/verify-email-phone',
  VerifyEmailAndPhoneOtp: '/verify-email-and-phone-otp',
  DailyFundPrice: '/daily-fund-price',
  DailyReports: '/daily-reports',
  Reports: '/reports',
  Configuration: '/configuration',
  UnitsReallocation: '/units-reallocation',

  // Super Admin Routes
  UserAudit: '/user-audit',
  EmployeeAudit: '/employee-audit',
  ComplaintAudit: '/complaint-audit',
  ChatAudit: 'chat-audit',
  TransactionAudit: 'transaction-audit',

  // Employer Admin Route List
  Employees: '/employees',
  EmployeeDetails: '/employee-details/:id',
  Contributions: '/contributions',

  /* AuthRouteList */
  SignIn: '/login',
  VerifyOtp: '/verifyotp',
  CreatePassword: '/createpassword/:empId/:token',
  ForgotPassword: '/forgotpassword',
  TokenError: '/tokenerror',
  NotFound: '*',
};

// export const AuthRouteList: any = {

// }

// export const PublicRouteList: any = {
//   NotFound: '*'
// }

export const userRoles = {
  superAdmin: 'Super Admin',
  admin: 'Admin',
  guest: 'Guest',
};

// Service

export const serviceRouteList: IServiceRouteListProps = {
  onfidoDocDetails: 'onfido-doc-details/',
  onfidoLiveImages: 'admin/onfido-live-images',
  customerProfile: 'api/admin/customer-profile/',
  onfidoVersion: '/v3.5/',
  getUserWithDraw: 'admin/user-withdraw',
  userFundDetails: 'user-wise-funds/fund-details/',
};

// Pages

export const pagesConstantList: IPagesConstantListProps = {
  documents: 'documents',
  livePhotos: 'live_photos',
  approve: 'Approve',
  reject: 'Reject',
  verify: 'Verify',
  rejected: 'Rejected',
  approved: 'Approved',
  new: 'New',
  closed: 'Closed',
  inProgress: 'In-progress',
  paymentPending: 'Payment Pending',
  ceo: 'ceo',
  mmEmployee: 'mm_employee',
  auditor: 'auditor',
  emptyString: '',
  zero: 0,
  string: undefined,
};
